import { render, staticRenderFns } from "./BizBusinessinfoMatch.vue?vue&type=template&id=8db6e702&scoped=true&"
import script from "./BizBusinessinfoMatch.vue?vue&type=script&lang=js&"
export * from "./BizBusinessinfoMatch.vue?vue&type=script&lang=js&"
import style0 from "./BizBusinessinfoMatch.vue?vue&type=style&index=0&id=8db6e702&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8db6e702",
  null
  
)

export default component.exports